/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-25 19:09:11
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-11 00:17:27
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\NumberWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import negate from "lodash/negate";
import includes from "lodash/includes";
import isFinite from "lodash/isFinite";


export default class NumberWidgetFilter extends WidgetFilter {
    eq(e) {
        return function (t) {
            return isFinite(t) && t === e
        }
    }
    ne(t) {
        return negate(this.eq(t))
    }
    gt(e) {
        return function (t) {
            return isFinite(t) && e < t
        }
    }
    gte(e) {
        return function (t) {
            return isFinite(t) && e <= t
        }
    }
    lt(e) {
        return function (t) {
            return isFinite(t) && t < e
        }
    }
    lte(e) {
        return function (t) {
            return isFinite(t) && t <= e
        }
    }
    range(i, a) {
        return function (t) {
            var e = !0;
            return isFinite(i) && (e = e && i <= t),
                !!(e = isFinite(a) ? e && t <= a : e)
        }
    }
    empty() {
        var e = this;
        return function (t) {
            return includes(e._getNullValues(), t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }
}
